// assets
import { IconAd2,IconUserPlus,IconDashboard ,IconMapPin,IconKey,IconTypography,IconPalette,IconLogout,IconWallet,IconCurrentLocation,IconGenderTransgender} from '@tabler/icons';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
// constant
const icons = { IconAd2,IconMapPin,IconUserPlus,IconDashboard ,IconKey,IconTypography,IconPalette,IconLogout,IconWallet,IconCurrentLocation,IconGenderTransgender,SummarizeOutlinedIcon};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //
const Admin = {
  id: 'dashboard',
  title: '',
  type: 'group',
  children: [
   
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/admin/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
  
    {
      id: 'register',
      title: 'Register',
      type: 'item',
      url: '/admin/register',
      icon: icons.IconAd2,
      breadcrumbs: false
    },
    {
      id: 'map',
      title: 'Map',
      type: 'item',
      url: '/admin/map',
      icon: icons.IconMapPin,
      breadcrumbs: false
    },
    {
      id: 'report',
      title: 'Reports',
      type: 'item',
      url: '/admin/report',
      icon: icons.SummarizeOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'users',
      title: 'Add / Remove Users',
      type: 'item',
      url: '/admin/users',
      icon: icons.IconUserPlus,
      breadcrumbs: false
    },
   
    {
      id: 'util-color2',
      title: 'Logout',
      type: 'item',
      url: '/login',
      icon: icons.IconLogout,
      breadcrumbs: false
    },
    
    // {
    //   id: 'authentication',
    //   title: 'Authentication',
    //   type: 'collapse',
    //   icon: icons.IconKey,

    //   children: [
    //     {
    //       id: 'login3',
    //       title: 'Login',
    //       type: 'item',
    //       url: '/pages/login/login3',
    //       target: true
    //     },
    //     {
    //       id: 'register3',
    //       title: 'Register',
    //       type: 'item',
    //       url: '/pages/register/register3',
    //       target: true
    //     }
    //   ]
    // }
  ]
};


export default Admin;
